import React from 'react';
import OptimizedImage from './common/OptimizedImage';

const JerseyCustomizationPreview = ({ image, name, number, alt }) => (
  <div className="jersey-custom-preview">
    <OptimizedImage src={image} alt={alt} sizes="(min-width: 901px) 55vw, 100vw" />
    <div className="jersey-custom-preview__print" aria-label="Aperçu de la personnalisation">
      <span>{name.trim().toUpperCase()}</span>
      <strong>{number}</strong>
    </div>
  </div>
);

export default JerseyCustomizationPreview;
